import React from 'react';

import PartFactBasic from './PartFactBasic';
import PartFactResult from './PartFactResult';
import { Tab, Tabs } from '../../components/Tabs';
import useUserContext from '../../hooks/useUserContext';

const tabs = [
  { label: 'basic', tabName: 'Данные для расчета', content: <PartFactBasic /> },
  { label: 'result', tabName: 'Просмотр факта выполнения', content: <PartFactResult /> },
];

export default function PartFact() {
  const userCtx = useUserContext();
  return (
    <section className="">
      <div style={{ marginTop: 20 }}>
        <Tabs>
          {tabs
            .filter((tab) => !tab.hide || !tab.hide(userCtx.perms))
            .map((tab, i) => (
              <Tab key={i} label={tab.label} tabName={tab.tabName}>
                {tab.content}
              </Tab>
            ))}
        </Tabs>
      </div>
    </section>
  );
}
